module.exports = __webpack_public_path__ + "static/media/295467.6526659e.png";